import {
  AddMessageAction,
  ADD_MESSAGE,
  ClearMessageAction,
  CLEAR_MESSAGE,
  Message,
} from './types';

function addMessage(message: Message): AddMessageAction {
  return {
    type: ADD_MESSAGE,
    message,
  };
}

function clearMessage(id: string): ClearMessageAction {
  return {
    type: CLEAR_MESSAGE,
    id,
  };
}

export const notificationActions = {
  addMessage,
  clearMessage,
};
